import { isModuleEntity } from "@client/lib/layout";
import { connectCustom } from "@client/lib/misc";
import { makeEntitySelector } from "@client/selectors";
import { type BaseAppState } from "@client/types";
import { type EntityContainerProps } from "./Container/container";
import Component, { type ViewerLayoutEntityComponentProps } from "./component";

const makeMapStateToProps = () => {
  const entitySelector = makeEntitySelector();

  return (state: BaseAppState, props: EntityContainerProps): ViewerLayoutEntityComponentProps => {
    const entity = entitySelector(state, props);
    return {
      ...props,
      gid: entity.gid,
      isModule: isModuleEntity(entity)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
